import moment from 'moment';

import { DATE_FORMAT } from 'common/constants/constants';
import Text from 'components/base/Text';
import { LineSkeleton } from 'components/base/Skeletons';

const DateCell = ({ date, isLoading }) => {
  const dateView = date ? moment(date).format(DATE_FORMAT) : 'N/A';

  if (isLoading) return <LineSkeleton />;

  return <Text size='medium'>{dateView}</Text>;
};

export default DateCell;
